<template>
  <v-app>
    <!-- App Bar - Navigasi Top -->
    <Top v-if="login"></Top>    
    <FrontHeader v-else />    
    <!-- Konten -->
    <v-main class="grey lighten-3">      
      <!-- Info (Progress Bar dan Alert) -->
      <Info></Info>
      <!-- Drawer Kiri -->
      <Drawer v-if="login"></Drawer>
      <!-- Router View -->
      <router-view />
    </v-main>

    <!-- Footer -->
    <Footer v-if="login"></Footer>
    <FrontFooter v-else />
  </v-app>
</template>

<script>
/* eslint-disable no-unused-vars */
import axios from 'axios'

import Top from '@/components/nav/Top.vue'
import Footer from '@/components/nav/Footer.vue'
import Drawer from '@/components/nav/Drawer.vue'
import Info from '@/components/info/Info.vue'
import FrontHeader from "./views/FrontHeader.vue"
import FrontFooter from "./views/FrontFooter.vue"


export default {
  name: 'App',
  components: {
    Top, Footer, Drawer, Info,
    FrontHeader,
    FrontFooter
  },
  data: function() {
    return {
      
    }
  },
  computed: {
    login: function() {
      return this.$store.getters.isAuthenticated
    }
  },
  created: function() {
    console.log('created app')
    axios.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
        // if you ever get an unauthorized, logout the user
          this.$store.dispatch('logout')
        }
        throw err;
      });
    });


  },
  beforeCreate: function() {
    console.log('before create app')
  }
};
</script>
